import React, { useEffect } from "react";
import Headertop from '../components/Headertop';
import Navbar from '../components/Navbar';
import Header from '../components/SubHeader-Course';
import Footer from '../components/Footer';
import { Link } from "react-router-dom";
import '../components/css/buttonStyle.css';
import add2 from '../components/advertisment/Asstright.png';
import add1 from '../components/advertisment/asstbottom.png';

function AssistantprofessorCourse (){
    useEffect(() => {
        const handleScroll = () => {
            const banner = document.querySelector(".footerimg");
            if (!banner) return;
                if (window.scrollY > 200) {
                    banner.classList.add("show");
                } 
                else {
                    banner.classList.remove("show");
                }
            };
            window.addEventListener("scroll", handleScroll);
            return () => window.removeEventListener("scroll", handleScroll);
        }, []);
    return (
        <>
            <Headertop /> 
            <Navbar />
            <Header />
            <div className="container my-5">
                <div className="row g-4">
                    <div className="col-lg-9">
                        <div className="row g-4">
                            <p>The JKPSC Assistant Professor selection process includes a written examination and Interview. To improve their JKPSC Assistant Professor exam scores, candidates should practice various JKPSC Assistant Professor previous year papers. By now, aspirants should have begun their preparations; if not, don't worry; we're here to assist. We have a few JKPSC Assistant Professor previous year question papers available for the candidates. JKPSC Assistant Professor previous year papers will benet candidates because they will be able to practice a variety of questions and get a sense of the types of questions that will be asked on the JKPSC Assistant Professor exam. By practicing with a variety of question sets, candidates can boost their condence, accuracy, and response time. JKPSC Assistant Professor previous year question papers are available by clicking on the links below.</p>
                        </div>

                        {/* <div className="yearbox mt-5 mb-5">
                            <p><b>Assistant Professor HPSC Question Paper (Total Tests: 3)</b></p>
                            <div className="downloadcards mb-3">
                                <div className="downloadcardsinner d-flex justify-content-between align-items-center">
                                    <div className="">
                                        <span className="badge bg-warning text-dark mb-2 rounded-1 px-2 py-1">PRO</span>
                                        <h5 className="fw-bold mb-1">HPSC Assistant Professor Exam. 2018</h5>
                                    </div>
                                    <div className="d-flex gap-2">
                                        <Link href='' target="_blank" className="btn btn-outline-danger downloadbtn">Download PDF</Link>
                                        <button className="btn btn-outline-denger downloadbtn"><i className="bi bi-lock-fill me-1"></i> Unlock Now</button>
                                    </div>
                                </div>
                            </div>

                            <div className="downloadcards mb-3">
                                <div className="downloadcardsinner d-flex justify-content-between align-items-center">
                                    <div className="">
                                        <span className="badge bg-warning text-dark mb-2 rounded-1 px-2 py-1">PRO</span>
                                        <h5 className="fw-bold mb-1">HPSC Assistant Professor Exam. 2018</h5>
                                    </div>
                                    <div className="d-flex gap-2">
                                        <Link href='' target="_blank" className="btn btn-outline-danger downloadbtn">Download PDF</Link>
                                        <button className="btn btn-outline-denger downloadbtn"><i className="bi bi-lock-fill me-1"></i> Unlock Now</button>
                                    </div>
                                </div>
                            </div>

                            <div className="downloadcards mb-3">
                                <div className="downloadcardsinner d-flex justify-content-between align-items-center">
                                    <div className="">
                                        <span className="badge bg-warning text-dark mb-2 rounded-1 px-2 py-1">PRO</span>
                                        <h5 className="fw-bold mb-1">HPSC Assistant Professor Exam. 2018</h5>
                                    </div>
                                    <div className="d-flex gap-2">
                                        <Link href='' target="_blank" className="btn btn-outline-danger downloadbtn">Download PDF</Link>
                                        <button className="btn btn-outline-denger downloadbtn"><i className="bi bi-lock-fill me-1"></i> Unlock Now</button>
                                    </div>
                                </div>
                            </div>
                        </div> */}
                        
                        <h4>Jharkhand Eligibility Test (JET) 2025</h4>
                        <p>Candidates who want to apply for Assistant Professor posts can appear for the Jharkhand Eligibility Test (JET). The application window will be available from 16 September and will remain open till 06 October on the ocial website of the commission i.e., jpsc.gov.in. The candidates can check more details on the JET 2025 by clicking on the link given below.</p>

                        <p>JET Notication 2025</p>

                        <p>JPSC Assistant Professor 2025 Overview</p>

                        <table class="table table-bordered">
                            <tbody>
                                <tr><th>Exam Particulars</th><th>Details</th></tr>
                                <tr><td>Exam Conducting Body</td><td>Jharkhand Public Service Commission (JPSC)</td></tr>
                                <tr><td>Post</td><td>Assistant Professor</td></tr>
                                <tr><td>Vacancy</td><td>2404 (expected)</td></tr>
                                <tr><td>Application Start Dates</td><td>To be announced</td></tr>
                                <tr><td>Last Date to Apply</td><td>To be announced</td></tr>
                                <tr><td>Mode of Application</td><td>Online</td></tr>
                                <tr><td>Exam Level</td><td>State</td></tr>
                                <tr><td>Exam Frequency</td><td>As required</td></tr>
                                <tr><td>Exam Purpose</td><td>Recruit Assistant Professors in Jharkhand</td></tr>
                                <tr><td>Ocial Website</td><td>JPSC Ocial Website</td></tr>
                            </tbody>
                        </table>

                        <h4>JPSC Assistant Professor Exam Dates 2025</h4>
                        <p>The JPSC Assistant Professor Exam Dates are announced on the website of the Jharkhand Public Service Commission, a few days before the exam. Candidates preparing for the recruitment must keep themselves updated about the exam dates to strategise their preparation.</p>

                        <table class="table table-bordered">
                            <tbody>
                                <tr><th>Event</th><th>Date</th></tr>
                                <tr><td>JPSC Assistant Professor Exam 2025</td><td>TBA</td></tr>
                            </tbody>
                        </table>

                        <h4>JPSC Assistant Professor Vacancy 2025</h4>
                        <p>A total of 2404 vacancies are to be be released under the JPSC Assistant Professor recruitment 2025. We will be updating the department-wise distribution of vacancies once it's out.</p>

                        <h4>JPSC Assistant Professor Application Process 2025</h4>
                        <p>The candidates need to ll out the JPSC Assistant Professor Application Form online through the JPSC ocial website and then send a hard copy of the same to the authorities. The step-by-step application process is explained below.</p>
                        <h5>Step 1: Visit the Ocial Website</h5>
                        <p>Go to the JPSC website. On the homepage, nd and click the link to apply for the JPSC Assistant Professor Recruitment.</p>

                        <h5>Step 2: Registration</h5>
                        <p>On the application portal, click "New Registration". Submit details like your name, date of birth and contact to complete the registration.</p>

                        <h5>Step 3: Fill Out the JPSC Assistant Professor Application Form</h5>
                        <p>Enter all the required details and complete the Jharkhand Assistant Professor online application form. Cross-check the details to avoid any errors.</p>

                        <h5>Step 4: Upload Documents</h5>
                        <p>Upload your photograph, signature and any other required documents in the given format.</p>

                        <h5>Step 5: Pay the Application Fee & Submit</h5>
                        <p>Verify all the details and pay the required application fee for your category. Submit the application online and save its copy on your device</p>

                        <h5>Step 6: Submit Hardcopies</h5>
                        <p>Take a printout of the application form, fee receipt, and the documents uploaded. Send these documents to the following address as per the instructions mentioned in the offcial no notication:</p>
                        <p>Controller of Examination,</p>
                        <p>Jharkhand Public Service Commission,</p>
                        <p>Circular Road,</p>
                        <p>Ranchi - 834001</p>

                        <h5>Jharkhand Assistant Professor Application Fee</h5>
                        <p>The JPSC Assistant Professor application fee can be paid through credit card/debit card/net banking/ challan via SBI collect. The fee concession given below is for the candidates of the Jharkhand state only.</p>

                        <table class="table table-bordered">
                            <tbody>
                                <tr><td>Category</td><td>Application Fee</td></tr>
                                <tr><td>UR/EWS/EBC/BC</td><td>Rs. 600</td></tr>
                                <tr><td>SC/ST</td><td>Rs.150</td></tr>
                            </tbody>
                        </table>

                        <h5>JPSC Assistant Professor Eligibility 2025</h5>
                        <p>The candidates need to full the Jharkhand Assistant Professor Eligibility in terms of age, qualication, and experience. An overview of the same is given below for reference. Make sure you meet these requirements before applying, and have the required documents to prove your eligibility.</p>
                        <ul>
                        <li>The applicants must have completed postgraduation in the concerned subject from a recognised university.</li>
                        <li>She/he must have qualied the Jharkhand Eligibility Test (JET).</li>
                        </ul>


                        <h5>JPSC Assistant Professor Selection Process 2025</h5>
                        <p>The Jharkhand Assistant Professor selection process is expected to include a personal interview and evaluation of academic qualications and work experience. The detailed weightage of the same or any changes will be updated once the ocial notication is released.</p>

                        <h5>JPSC Assistant Professor Salary Details</h5>
                        <p>The JPSC Assistant Professor Salary will be as per Pay Band-3, with a pay scale of Rs. 15600-39100. The Grade Pay for this post will be Rs.6600. Candidates appointed to this post will serve a 2-year probation.</p>

                        <h5>JPSC Assistant Professor Admit Card 2025</h5>
                        <p>The Jharkhand Assistant Professor Hall Ticket is made available on the JPSC website 5-10 days before the exam. It is an important document which contains details about the exam date, time, location of the exam centre, and exam day instructions for the candidates. Those appearing for the exam must download their admit cards and carry its printout to the exam centre on the exam day. WIthout it their entry will be barred.</p>

                        <h5>JPSC Assistant Professor Cut Off 2025</h5>
                        <p>The JPSC Assistant Professor Cut Off is announced after the exam on the commission's website. The candidates need to secure at least 18 marks out of the 46 marks allotted for educational eligibility, work experience, and interview. The cut off may vary according to the number of vacancies against the number of applicants.</p>

                        <h5>JPSC Assistant Professor Result 2025</h5>
                        <p>The Jharkhand Assistant Professor Result is declared on the JPSC website in a few weeks after the exam is conducted. The merit list of the selected candidates will be uploaded on the website in a category-wise format. The applicants can check their results by searching for their roll number in the merit list.</p>
                        <p>Hopefully, this article on the JPSC Assistant Professor Recruitment was informative for all the eligible candidates. For the preparation of various Govt job exams through live coaching, mock tests, etc. download the Vigyan Vriksh App.</p>
                    </div>

                    <div className="col-lg-3">
                        <div className="sidebar-box">
                            <h5>Search</h5>
                            <div className="input-group mt-3">
                                <input type="text" className="form-control" placeholder="Enter Keyword" />
                                <button className="btn btn-light"><i className="bi bi-search"></i></button>
                            </div>
                        </div>
                        <div className="sidebar-box">
                            <h5>Recent Posts</h5>
                            <div className="recent-post mt-3">
                                <ul className="list-unstyled">
                                    <li><Link to="/Upgiclecturerrecruitment2025">UP GIC Lecturer Recruitment 2025 Apply Online, Eligibility, Fee, Last Date</Link></li>
                                    <li><Link to="/RPSCSchoollecturer2025">RPSC School Lecturer Recruitment 2025 [3225 Post] Apply Online</Link></li>
                                    <li><Link to="/GATEExamination2026">GATE Examination 2026</Link></li>
                                    <li><Link to="/BiharBPSCAESRecruitment2025">Read More</Link></li>
                                </ul>
                                <div>
                                    <p className="mb-0"></p>
                                </div>
                            </div>
                            <img src={add2} className="courseBanner" alt="" />
                        </div>
                    </div>
                </div>
            </div>
            <Footer />
            <img src={add1} className="footerimg" alt="" />
        </>
    );
}
export default AssistantprofessorCourse;